import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function AdminUsers() {
  const { t } = useI18n();
  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {});
    api.get("/admin/messages").then((r) => setMessages(r.data)).catch(() => {});
  }, []);

  useEffect(load, [load]);

  return (
    <div data-testid="admin-users-panel">
      <div className="overflow-x-auto border border-[#C69A3B]/30 bg-white">
        <table className="w-full min-w-[600px] text-sm">
          <thead className="bg-[#F6F0E4] text-left">
            <tr className="label-mono">
              <th className="p-3">{t("auth.name")}</th>
              <th className="p-3">{t("auth.email")}</th>
              <th className="p-3">{t("account.role")}</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} data-testid={`admin-user-row-${u.email}`} className="border-t border-[#D8D3CB]">
                <td className="p-3">{u.name}</td>
                <td className="p-3">{u.email}</td>
                <td className="p-3">
                  <select
                    data-testid={`admin-user-role-${u.email}`}
                    value={u.role}
                    onChange={async (e) => {
                      await api.patch(`/admin/users/${u.user_id}/role`, { role: e.target.value });
                      toast.success(e.target.value);
                      load();
                    }}
                    className="min-h-[40px] border border-[#C69A3B]/60 px-2 text-sm"
                  >
                    <option value="client">client</option>
                    <option value="contributor">contributor</option>
                    <option value="admin">admin</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3 className="mt-10 font-serif-display text-xl text-[#8F3329]">{t("admin.messages")}</h3>
      <ul className="mt-4 space-y-3 text-sm" data-testid="admin-messages-list">
        {messages.length === 0 && <li className="text-[#5A5752]">—</li>}
        {messages.map((m) => (
          <li key={m.id} className="border border-[#C69A3B]/30 bg-white p-4">
            <p className="font-medium">
              {m.name} · {m.email}
            </p>
            <p className="mt-1 text-xs text-[#5A5752]">
              {m.event_type} {m.event_date} {m.location}
            </p>
            <p className="mt-2">{m.message}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
